import { default as _ } from 'underscore';

import {
  SWITCH_TECHNICAL_CARD_TAB,
  TECHNICAL_CARD_UPLOAD_SUCCESS,
  CAR_DATA_FORM_VALUES_SUCCESS,
  STORE_CAR_DATA_FORM_VALUES_SUCCESS,
  STORE_CAR_DATA_FORM_VALUES,
  CLEAR_CAR_DATA_STORE,
  STOP_LOADING_CAR_DATA,
  SET_CLIENT_CAR_PLATE
} from './types';

import {
  SAVE_QUERY_PARAMS
} from '../types';

import { getUrlVars, generateRandomPlate } from "../../../utils";


const INITIAL_STATE = {
  activeKey: 'noTechnicalCardPhoto',//TODO: JOSELITO borrar => es del B2C
  technicalCardPhoto: null,
  carDataData: null,
  carDataOptions: null,
  carDataEngines: null,
  canRedirect: null,
  loading: true,
  clientCarPlate: getUrlVars()['plate'] ? getUrlVars()['plate'].replace(/ /g, '').replace(/%20/g, '') : generateRandomPlate(),
  kilometres: getUrlVars()['kms'] ? getUrlVars()['kms'] : null,
};

export default function (state = INITIAL_STATE, action) {
  const carDataData = { ...state.carDataData };
  switch (action.type) {
    case SWITCH_TECHNICAL_CARD_TAB:
      return {
        ...state,
        activeKey: action.payload.newTab,
      };
    case TECHNICAL_CARD_UPLOAD_SUCCESS:
      return {
        ...state,
        technicalCardPhoto: action.payload.file,
      };
    case CAR_DATA_FORM_VALUES_SUCCESS:
      return {
        ...state,
        carDataOptions: action.payload.data,
        carDataEngines: action.payload.engines,
      };
    case STORE_CAR_DATA_FORM_VALUES_SUCCESS:
      return {
        ...state,
        carDataData: action.payload.values,
        canRedirect: true,
      };

    case STORE_CAR_DATA_FORM_VALUES:
      return {
        ...state,
        carDataData: action.payload.values,
      };
    case CLEAR_CAR_DATA_STORE:
      let cleaned = {};
      _.each(action.payload.props, (p) => {
        cleaned[p] = INITIAL_STATE[p];
      });
      return {
        ...state,
        ...cleaned
      };
    case STOP_LOADING_CAR_DATA:
      return {
        ...state,
        loading: false,
      }
    case SAVE_QUERY_PARAMS:
      carDataData.make = action.queryParams.make;
      carDataData.model = action.queryParams.model;
      carDataData.year = action.queryParams.year;
      carDataData.plate = action.queryParams.plate;
      carDataData.engine = action.queryParams.engine;
      carDataData.kilometres = action.queryParams.kilometres;
      return {
        ...state,
        carDataData,
      }
    case SET_CLIENT_CAR_PLATE:
      return {
        ...state,
        clientCarPlate: action.payload.clientCarPlate,
      }
    default:
      return {
        ...state,

      };
  }
}



// WEBPACK FOOTER //
// ./src/workflow/checkout/carData/reducer.js